export const getSiteName = () => {
  const theme = process.env.VUE_APP_USE_THEME;
  const refcode = localStorage.getItem("refcode");

  if (theme === "WLC_ADMIN") {
    if (refcode === "moph") {
      return "MOPH_ADMIN";
    }

    return "WLC_ADMIN";
  }

  return theme;
};
